import React from 'react';
import urlBase from '../../url-base';
import axios from 'axios';
import InputMask from 'react-input-mask';
import {
  Alert, Container, Row, Col, Button
} from 'reactstrap';
import MenuNew from '../MenuNew';
import NavbarDrop from '../HomePageNew/NavbarDrop';
import Footer from '../HomePageNew/Footer';
//import Contact from '../HomePageNew/Contact';


class SearchForProposalStatus extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      status : ''
    };

    this.styles = {
      
    };
  }

  componentWillMount() {
    window.location.href='https://institucional.planodentalcenter.com.br';

  }
  componentDidMount() {
    window.location.href='https://institucional.planodentalcenter.com.br';

  }

	validateCpf(id, send=false, event) {
    event.preventDefault();

    let cpf  = document.getElementById(id).value.replace(/[^0-9]/g,'');
    let test = true;
    let add  = 0, i = 0, rev = 0;

    if (cpf.length != 11 || 
        cpf == "00000000000" || 
        cpf == "11111111111" || 
        cpf == "22222222222" || 
        cpf == "33333333333" || 
        cpf == "44444444444" || 
        cpf == "55555555555" || 
        cpf == "66666666666" || 
        cpf == "77777777777" || 
        cpf == "88888888888" || 
        cpf == "99999999999"){
      test = false;
    }else{
      // Valida 1° digito	
      for (i=0; i < 9; i ++)		
        add += parseInt(cpf.charAt(i)) * (10 - i);	
        rev = 11 - (add % 11);	
        if (rev == 10 || rev == 11){		
          rev = 0;
        }	
        if (rev != parseInt(cpf.charAt(9))){		
          test = false;          	
        }	
      // Valida 2° digito	
      add = 0;	
      for (i = 0; i < 10; i ++){	
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }	
      rev = 11 - (add % 11);	
      if (rev == 10 || rev == 11){
        rev = 0;
      }	
      if (rev != parseInt(cpf.charAt(10))) {
        test = false;
      }
    }
    if (test == true) {
      document.getElementById("alert_second_payment_cpf").style.display = "none";

      if (send) {
        document.getElementById('loading_second_payment_cpf').style.display = 'block';
        this.formProposalStatus(id);
      }
    }
    else {
      document.getElementById('loading_second_payment_cpf').style.display = 'none';
      document.getElementById("alert_second_payment_cpf").innerHTML = "*CPF inválido!";
      document.getElementById("alert_second_payment_cpf").style.display = "block";
      let state = this.state;
      state.status = '';
      this.setState(state);
    }
  }

	formProposalStatus(id) {
		let cpf = document.getElementById(id).value;
    let	url = urlBase.loopBack+'Sales/SalesByCpf';

    let	dataPost = {
      cpf: cpf
    };

    axios.post(url, dataPost)
    .then((result) => {
      if (result.data.status == 'success') {
        let state = this.state;
        if (result.data.sales.status == 'EM VALIDAÇÃO' && result.data.afterSales == true)
          state.status = 'PÓS VENDA';
        else
          state.status = result.data.sales.status;

        this.setState(state);
        document.getElementById('loading_second_payment_cpf').style.display = 'none';
        document.getElementById("alert_second_payment_cpf").style.display = "none";
        document.getElementById('i_scroll_into_view').scrollIntoView();
      }
      else {
        let state = this.state;
        state.status = '';
        this.setState(state);

        document.getElementById('loading_second_payment_cpf').style.display = 'none';
        document.getElementById("alert_second_payment_cpf").innerHTML = result.data.message;
        document.getElementById("alert_second_payment_cpf").style.display = "block";
      }
    })
    .catch(function () {
      let state = this.state;
      state.status = '';
      this.setState(state);

      document.getElementById('loading_second_payment_cpf').style.display = 'none';
      document.getElementById("alert_second_payment_cpf").innerHTML = "Erro ao pesquisar CPF";
      document.getElementById("alert_second_payment_cpf").style.display = "block";
    }.bind(this));
  }

  //busca dados do usuario no endpoint - usuarios
	form_cpf() {
		let cpf = document.getElementById("second_payment_cpf").value;
    let	url = urlBase.loopBack+'APIS4s/Associados';

    let	dataPost = {
      cpf: cpf
    };

    axios.post(url, dataPost)
    .then((result) => {
      if (result.data.length > 0) {
        //faz a busca da segunda via do boleto
        let code = result.data[0].Id;
        this.second_payment_slip(code);
      }
      else {
        document.getElementById('loading_second_payment_cpf').style.display = 'none';
        document.getElementById("alert_second_payment_cpf").innerHTML = "CPF não encontrado, entre em contado com a dental center através do número (83) 3041-4646";
        document.getElementById("alert_second_payment_cpf").style.display = "block";
        let state = this.state;
        state.secondPayment = [];
        this.setState(state);
      }
      
    })
    .catch(function () {
      document.getElementById('loading_second_payment_cpf').style.display = 'none';
      document.getElementById("alert_second_payment_cpf").innerHTML = "Ocorreu um erro ao buscar os dados do CPF";
      document.getElementById("alert_second_payment_cpf").style.display = "block";
      let state = this.state;
      state.secondPayment = [];
      this.setState(state);
    }.bind(this));
     
  }

  //faz a busca da segunda via do boleto pelo codigo(que é o id do usuario), no endpoint mensalidades
  second_payment_slip(code) {
    let	url = urlBase.loopBack+'APIS4s/Mensalidades';
   
    let	dataPost = {
      codigo: code.toString()
    };

    axios.post(url, dataPost)
    .then((result) => {
      if (result.data.length > 0) {
        let state = this.state;
        state.secondPayment = result.data.reverse();
        state.layout = true;
        this.setState(state);
        document.getElementById('loading_second_payment_cpf').style.display = 'none';
        document.getElementById("alert_second_payment_cpf").style.display = "none";
      }
      else {
        document.getElementById('loading_second_payment_cpf').style.display = 'none';
        document.getElementById("alert_second_payment_cpf").innerHTML = "Boletos não encontratos para este CPF";
        document.getElementById("alert_second_payment_cpf").style.display = "block";
        let state = this.state;
        state.secondPayment = [];
        this.setState(state);
      }
    })
    .catch(function () {
      document.getElementById('loading_second_payment_cpf').style.display = 'none';
      document.getElementById("alert_second_payment_cpf").innerHTML = "Ocorreu um erro ao buscar os boletos para este CPF";
      document.getElementById("alert_second_payment_cpf").style.display = "block";
      let state = this.state;
      state.secondPayment = [];
      this.setState(state);
    }.bind(this));
  }

  render() {
    return (
      <div>
        <MenuNew />
        <NavbarDrop />

        <Container id="payment_slip">
          <div className="proposal_status_img">
            <Row style={{marginRight: 0}}>
              <Col style={{marginTop:60}} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>

              <Col id="payment_slip_app_text" xs="12" sm="12" md="8" lg="8" xl="8">
                <h1>
                  SITUAÇÃO DE SUA PROPOSTA
                </h1>

                <form onSubmit={this.validateCpf.bind(this, "second_payment_cpf", true)}>
                  <label>INSIRA O CPF DO TITULAR ABAIXO</label>
                  <div>
                    <div>
                      <i id="loading_second_payment_cpf"
                        style={{ display: 'none', width: 16, margin: '0 auto 8px auto'}}
                        className="fa fa-spinner fa-spin">
                        &nbsp;
                      </i>
                    </div>
                    <Alert id="alert_second_payment_cpf">{''}</Alert>
                    <InputMask
                      id="second_payment_cpf"
                      className="ant-input input_second_payment"
                      mask="999.999.999-99"
                      maskChar=" "
                      type="tel"
                      onBlur={this.validateCpf.bind(this, "second_payment_cpf", false)}
                      placeholder="CPF DO TITULAR*"
                    />
                  </div>
                  <Button
                    className="button_you_family"
                    onClick={this.validateCpf.bind(this, "second_payment_cpf", true)}
                    type="submit"
                  >
                    BUSCAR
                  </Button>
                </form>
              </Col>

              <Col style={{marginTop:60}} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>
            </Row>
          </div>

          {
            this.state.status.length > 0 ? (
          <div id="i_scroll_into_view">
            <hr />

            <div id="payment_slip_app">
              <Row style={{marginRight: 0}}>
                <Col className="payment_slip_app_col" xs="12" sm="12" md="12" lg="12" xl="12">
                  <div style={{textAlign: 'center', marginTop: 45}}>
                    <p style={{color: '#495057'}}>
                      Sua proposta está com a situação:
                    </p>

                    <p style={{fontSize: 25, color: '#f5aa0f'}}>
                      <strong>{this.state.status}</strong>
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
            ) : ('')
          }


          <hr />
        </Container>

        {/* Retirar a seção de contatos da página 
        <Contact />
        */}
        <Footer />
      </div>

    );
  }
}
export default SearchForProposalStatus;



/** WEBPACK FOOTER **
 ** ./src/components/ProposalStatusNew/SearchForProposalStatus.js
 **/